module.exports = __webpack_public_path__ + "img/base.60cd4eb6.png";